import React from "react"
import containerStyles from "./index.module.css"

function Hero() {
  return <div className="ui two column grid">
    <div className="row">
      <div className={"column " + containerStyles.hero_left}>
        <h1 className={containerStyles.hero_left_logo}>KLS <strong>Konsulent AS</strong></h1>
        <p className={containerStyles.hero_left_p}>Trenger du en fullstack it konsulent med lidenskap for kode innen back-end, app eller embedded verdenen?</p>
      </div>
      <div className={"column " + containerStyles.hero_right}>
        <img src="/profile_image.jpg" alt="Kristoffer" className={containerStyles.hero_right_profile_img} />
      </div>
    </div>
  </div>
}

function Whoami() {
  return <div className={"row " + containerStyles.whoami}>
    <h1>Hvem er jeg?</h1>
    <p>Hei! Jeg heter Kristoffer og er en selvstendig konsulent som jobber fra Oslo. Jeg er en fullstack utvikler, men spesialiserer meg innen back-end, app, og embedded utvikling. Med en lidenskap for produktutvikling er jeg en god ressurs å ha på et hvert utviklerteam.</p>
  </div>
}

function Experience() {
  return <div className={"row " + containerStyles.experience}>
    <h1>Erfaring</h1>
    <ul>
      <li>
        Seniorkonsulent, KLS Konsulent AS
        <small>2020 – Nå</small>
      </li>
      <li>
        VP AV1-Series, No Isolation AS
        <small>2017 – 2019</small>
      </li>
      <li>
        Systemutvikler, No Isolation AS
        <small>2016 – 2017</small>
      </li>
      <li>
        Konsulent, Min Utvikler ENK
        <small>2009 – 2016</small>
      </li>
    </ul>
  </div>
}

function Education() {
  return <div className={"row " + containerStyles.education}>
    <h1>Utdanning</h1>
    <ul>
      <li>
        NTNUs Entreprenørskole
        <small>2014 – 2015, Sivilingeniør / Master i teknologi</small>
      </li>
      <li>
        Boston School of Management
        <small>2014, Norwegian Entrepreneurship Program</small>
      </li>
      <li>
        NTNU Kommunikasjonsteknologi
        <small>2010 – 2013/15, Sivilingeniør / Master i teknologi</small>
      </li>
    </ul>
  </div>
}

function Contact() {
  return <div className={"row " + containerStyles.contact}>
    <h1>Ta kontakt</h1>
    <p className={containerStyles.contact_p}>
      +47 971 63 297 <br />
      kristoffer@klskonsulent.no
    </p>
  </div>
}

function Footer() {
  return <div className={"row " + containerStyles.footer}>
    <p className={containerStyles.footer_p}>© KLS Konsulent AS, Oslo, 2020</p>
  </div>
}

export default function Home() {
  return <div className="ui container">
    <Hero />
    <div className="ui grid">
      <Whoami />
      <Experience />
      <Education />
      <Contact />
      <Footer />
    </div>
  </div>
}
